var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticStyle:{"height":"40px","width":"40px","border-radius":"50%"},attrs:{"src":"/avatar.png","alt":""}})}
var staticRenderFns = []

export { render, staticRenderFns }